import { render } from "./ScoutReports.vue?vue&type=template&id=2fae7b3e"
import script from "./ScoutReports.vue?vue&type=script&lang=js"
export * from "./ScoutReports.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__